import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AngularFirestore } from '@angular/fire/firestore';
import { LanguageService } from 'typescript';
import { TranslationService } from 'src/app/modules/core/services/translation.service';
import { LocalStoreService } from './local-store.service';

export interface Notification {
  id: string;
  channel: string;
  type: string;
  template: {
    name: string;
    type?: string;
  };
  notification: {
    [key: string]: {
      title: string;
      body: string;
      bodyHtml: string;
      data: {
        [key: string]: any;
      };
    };
  };
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  public messages = new BehaviorSubject<Notification>(null);

  constructor(
    private angularFireMessaging: AngularFireMessaging,
  ) { }

  requestPermission(
    successCallback: (token: string) => void,
    errorCallback: (error: any) => void
  ) {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        successCallback(token);
      },
      (error) => {
        errorCallback(error);
      }
    );
  }

  receiveMessage() {
    this.angularFireMessaging.onMessage((payload) => {
      const parsedData = payload.notification.body;
      this.messages.next(parsedData);
    });
  }
}
